import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Components/AuthContext";
import { addEspaceCharacters, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from "../Components/LoaderBox";

function TipoDeEjeAgregar() {
  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
    redirect: false,
    page: "/TipoDeEje",
  });
  const [openDialog, setOpenDialog] = React.useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    instance
      .post("/tipoDeEje/", {
        id: user.id,
        nombre: addEspaceCharacters(info.nombre.value),
      })
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: "El tipo de eje ha sido creada exitosamente.",
          redirect: true,
          page: "/TipoDeEje",
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };
  return (
    <LoaderBox>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Typography component="h1" variant="h5">
            Nuevo tipo de eje
          </Typography>
          <Box
            component="form"
            sx={{
              mt: 1,
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              width: "100%",
            }}
            onSubmit={handleSubmit}
          >
            <TextField
              margin="normal"
              label="Nombre"
              id="nombre"
              name="nombre"
              autoFocus
              required
              fullWidth
              inputProps={{ maxLength: 100 }}
            />
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ width: { xs: "100%", sm: "50%" } }}
              >
                Agregar
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
      />
    </LoaderBox>
  );
}

export { TipoDeEjeAgregar };
